<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="mono-logo-container text-center">
        <img src="@/assets/logo_white.svg" alt="Traitstack">
      </div>
      <div class="field-error" :class="{ toggled: error }">{{ errorMessage }}</div>
      <div id="authPanel" class="panel auth-panel">
        <h1 class="h2">Sign in</h1>
        <div v-if="phase == 0">
          <form v-on:submit.prevent>
            <input
              ref="email"
              type="text"
              name="email"
              v-model="email"
              class="form-control"
              placeholder="Email address"
            />
            <input type="password" name="password" v-model="password" class="form-control" placeholder="Password" />
            <button
              ref="button"
              name="submit"
              type="submit"
              @click="signIn"
              class="btn btn-primary btn-auth btn-loader"
              :class="{ active: loading, success: success }"
            >
              <span>Sign in to Traitstack</span>
            </button>
          </form>

          <div class="divider-text">
            <span>or continue with</span>
          </div>
          <div class="row">
            <div class="col-md-6">
              <button @click="signInWithSocial('google')" class="btn btn-secondary btn-auth">
                <img src="@/assets/icon_google.png" alt />
                <span>Google</span>
              </button>
            </div>
            <div class="col-md-6">
              <button @click="signInWithSocial('facebook')" class="btn btn-secondary btn-auth">
                <img src="@/assets/icon_facebook.png" alt />
                <span>Facebook</span>
              </button>
            </div>
          </div>
          <p class="auth-info">
            Don’t have an Traitstack account yet?
            <router-link to="/sign-up">Sign up</router-link>
          </p>
          <p class="auth-info">
            Unable to sign in?
            <router-link to="/reset-password">Reset your password</router-link>
          </p>
        </div>
        <div v-if="phase == 1">
          <p>
            There is no account with the email
            <b>{{ emailAddress }}</b> in the system.
          </p>
          <p>Do you wish to create a new account?</p>
          <div class="text-center mt-4">
            <button
              ref="button"
              @click="socialNewAccountCreate"
              class="btn btn-primary btn-loader"
              :class="{ active: loading, success: success }"
            ><span>Create new account</span></button>
            <button
              ref="button"
              @click="socialNewAccountRemove"
              class="btn btn-tertiary btn-loader"
              :class="{ active: loading, success: success }"
            ><span>Cancel</span></button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "signin",
  components: {},
  mounted() {        
    this.$refs.email.focus();
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: false,
      errorMessage: "",
      success: false,
      phase: 0,
      emailAddress: ""
    };
  },
  methods: {
    resetErrorState() {
      this.loading = false;
      this.success = false;
      this.error = false;
    },
    displayErrorPanelWithMessage(message) {
      this.errorMessage = message;
      this.loading = false;
      this.error = true;
      document.getElementById("authPanel").classList.remove("error");
      void document.getElementById("authPanel").offsetWidth;
      document.getElementById("authPanel").classList.add("error");
    },
    signIn: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            this.loading = false;
            this.success = true;
            this.error = false;
            this.$router.replace({ path: "/" });
          },
          error => {
            this.displayErrorPanelWithMessage(error.message);
          }
        );
    },
    signInWithSocial: function(authProvider) {

      if (this.loading) {
        return;
      }
      this.loading = true;
      let provider = null;

      if (authProvider == "google") {        
        provider = new firebase.auth.GoogleAuthProvider();
      } else if(authProvider == "facebook") {
        provider = new firebase.auth.FacebookAuthProvider();
      }

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          if (result.additionalUserInfo.isNewUser) {
            this.resetErrorState();
            this.phase = 1;
            this.emailAddress = result.user.email;
            this.$router.replace({ path: "/sign-in#newAccount" });
          } else {
            this.$router.replace({ path: "/" });
          }
        })
        .catch(error => {
          this.displayErrorPanelWithMessage(error.message);
        });
    },
    socialNewAccountCreate: function() {
      this.$router.replace({ path: "/sign-up" });
    },
    socialNewAccountRemove: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      var removeAccount = firebase.functions().httpsCallable("removeAccount");

      const friendsList = [];

      removeAccount({
        friendsList: friendsList
      })
        .then(() => {
          firebase
            .auth()
            .signOut()
            .then(
              () => {
                this.phase = 0;
                this.$root.$detachListeners();
                this.resetErrorState();
              },
              error => {
                this.$errorMessage(error.message);
              }
            );
        })
        .catch(error => {
          this.$errorMessage(error.message);
        });
    }
  }
};
</script>
